import React, { useState } from "react";
import { Accordion, Container } from "react-bootstrap";

// const faqData = [
//   { question: "What is Falcon React?", answer: "Falcon React is a premium admin dashboard template built with React and Bootstrap." },
//   { question: "How do I install Falcon React?", answer: "You can install it via npm or yarn by following the documentation." },
//   { question: "Is Falcon React mobile-friendly?", answer: "Yes, Falcon React is fully responsive and optimized for mobile devices." },
//   { question: "Can I customize the components?", answer: "Absolutely! Falcon React provides customizable components that you can style as needed." },
//   { question: "Does Falcon React support dark mode?", answer: "Yes, Falcon React comes with a built-in dark mode support." },
//   { question: "How do I get support for Falcon React?", answer: "You can contact the support team through their official website or documentation." },
//   { question: "Does Falcon React work with Redux?", answer: "Yes, Falcon React is compatible with Redux and other state management libraries." },
//   { question: "Is there a free version available?", answer: "Falcon React is a premium template, but you may find a free demo version on their website." },
//   { question: "Can I use Falcon React for commercial projects?", answer: "Yes, Falcon React is designed for both personal and commercial use." },
//   { question: "How often is Falcon React updated?", answer: "Falcon React is regularly updated with new features and bug fixes." }
// ];

// const faqData = [
//   { question: "Can I manage multiple properties with this software?", answer: "Yes, you can manage multiple properties under a single property management company using our software." },
//   { question: "How does a free 30-day trial work?", answer: "Our free 30-day trial gives you full access to all features of our property management software, allowing you to explore its capabilities without any commitment. No credit card is required to start, and you can cancel anytime. At the end of 30 days, you can choose to subscribe to a paid plan or discontinue using the service." },
//   { question: "Does the software integrate with Stripe, PayPal or other payment processors?", answer: "Our software integrates with Stripe payment processor and you and your residents can do online payments via using credit cards. Stripe payment fees and taxes are the property management company’s responsibility. Condozak does not cover these charges. By enabling Stripe, you agree to all applicable deductions per Stripe’s terms." },
//   { question: "Is my data secure?", answer: "Yes, your data is highly secure. We use industry-leading security measures, including encrypted storage, advanced firewalls, and strict access controls. Our infrastructure is hosted on trusted cloud platforms, and we have multiple layers of protection in place to safeguard your information from any threats. Only authorized personnel have access, ensuring your data remains private and protected at all times." },
//   { question: "Can I turn off or disable any of these features?", answer: "Yes! You can very easily turn features on or off that you don’t need for your property. When disabled, no one will be able to access them, or even know they are there." },
//   { question: "Do you have a mobile app?", answer: "Our software is responsive and compatible with all modern web browsers. You can just open your community website address link in any browser on your mobile phone to access it seamlessly." },
//   { question: "Do you provide customer support?", answer: "Yes, you can contact us at +1 (647) 860-2211 or email us at info@condozak.ca for any customer support." }
// ];

const faqData = [
  {
    question: "What pricing plans does CONDOZAK™ offer?",
    answer:
      "Currently, CONDOZAK™ offers a single comprehensive plan called CORE, which includes full access to all available features. Pricing is structured based on the number of condo units you manage.",
  },
  {
    question: "Do you offer a free trial?",
    answer:
      "Yes, CONDOZAK™ provides a generous 30-day free trial, allowing you to explore all features without providing credit card details upfront.",
  },
  {
    question: "Can I manage multiple properties under one account?",
    answer:
      "Yes, you can easily manage multiple properties within a single CONDOZAK™ account.",
  },
  {
    question:
      "Can I change my subscription tier if the number of units I manage changes?",
    answer:
      "Yes. If the number of condo units you manage exceeds your current tier, your billing will automatically be adjusted to the new tier starting the following month.",
  },
  {
    question: "Does CONDOZAK™ integrate with payment processors?",
    answer:
      "Yes, CONDOZAK™ integrates with Stripe for online credit card payments. Stripe's fees apply.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept all major credit cards and offer convenient automatic monthly billing options.",
  },
  {
    question: "Is there a setup or onboarding fee?",
    answer:
      "No, CONDOZAK™ does not charge any setup or onboarding fees. Our team provides free onboarding assistance to ensure a smooth start.",
  },
  {
    question: "Can I cancel my subscription at any time?",
    answer:
      "Yes, you can cancel your subscription at any time. Your access will remain active until the end of your current billing period.",
  },
  {
    question: "Does CONDOZAK™ provide customer support?",
    answer:
      "Yes, our CORE plan includes dedicated customer support via email and phone. Phone support is available from 9:00 am to 9:00 pm Eastern Time.",
  },
  {
    question: "How secure is my data with CONDOZAK™?",
    answer:
      "Data security is a top priority. CONDOZAK™ employs advanced security measures, including encryption, regular backups, and adherence to industry-leading data protection standards.",
  },
];

const FaqAccordion = () => {
  const [activeKey, setActiveKey] = useState(null);

  return (
    <Container className="py-4">
      <h2 className="text-center mb-4">Frequently Asked Questions</h2>
      <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
        {faqData.map((faq, index) => (
          <Accordion.Item eventKey={String(index)} key={index}>
            <Accordion.Header>{faq.question}</Accordion.Header>
            <Accordion.Body className="">
              {faq.answer}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </Container>
  );
};

export default FaqAccordion;
